import { ROLES } from "./asiRoleResolverClient";

const ASI_LAUNCHER_ROLES = new Set(Object.values(ROLES));

/**
 * Whether launcher should surface Applied Superintelligence for this user.
 * True when they hold any known asiRoleAssignments role or an active
 * asiStaffAssignments grant.
 */
export function userHasAsiLauncherGrant({
  assignments = [],
  staffAssignment = null,
} = {}) {
  const hasRole = (Array.isArray(assignments) ? assignments : []).some(
    (row) => row?.role && ASI_LAUNCHER_ROLES.has(row.role),
  );
  const hasStaff = Boolean(
    staffAssignment && staffAssignment.active !== false,
  );
  return hasRole || hasStaff;
}
